import React from "react";
import styles from "./styles.module.scss";
import theme from "../../../Styles/theme.scss";
import { toSnakeCase } from "Services/Utils/toSnakeCase";

const Step2 = ({
  setReportType,
  reportTypes,
  reportType,
  serviceUser,
  onTrack,
}) => {
  const getIconColour = (type) => {
    if (!type.available) {
      return theme.neutral3;
    }
    return reportType.id === type.id ? theme.neutral7 : theme.neutral5;
  };

  const fillPlaceholderWithSUName = (string) => {
    return string.replace("<placeholder_name>", serviceUser?.label);
  };

  return (
    <div className={styles.reportType}>
      <h2>Select a report type</h2>
      <div className={styles.reportType_row}>
        <div className={styles.newReportContainer}>
          <div className={styles.reportTypeContainer}>
            {reportTypes.map((type, index) => {
              return (
                <div
                  key={index}
                  className={`${
                    reportType.id === type.id
                      ? styles.focusedReportTypeButton
                      : styles.reportTypeButton
                  } ${type.available ? styles.available : styles.unavailable}`}
                  onClick={() => {
                    type.available && setReportType(type);
                    type.available &&
                      onTrack({
                        action: "report_type_selected",
                        report_type: toSnakeCase(type.id),
                      });
                  }}
                >
                  <type.icon colour={getIconColour(type)} />

                  <div className={styles.reportTypeButtonTitle}>
                    {type.title}
                  </div>
                  {!type.available && (
                    <div className={styles.reportType_comingSoon}>
                      (coming soon)
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.whatsIncludedContainer}>
          <div className={styles.title}>What is included in this report?</div>
          <div className={styles.horizontalBar} />
          <>
            <div className={styles.subheading}>
              This report type will provide you with evidence to the questions
              below.
            </div>
            {reportType.sections?.map((section, i) => {
              return (
                <div className={styles.section} key={`${section.title}-${i}`}>
                  <div className={styles.sectionTitle} data-private>
                    {fillPlaceholderWithSUName(section.title)}
                  </div>
                  <ol className={styles.list}>
                    {section.questions?.map((item, i) => (
                      <li className={styles.item} data-private key={i}>
                        {fillPlaceholderWithSUName(item)}
                      </li>
                    ))}
                  </ol>
                </div>
              );
            })}
          </>
        </div>
      </div>
    </div>
  );
};

export default Step2;
